import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Typography, Box, FormControl, InputLabel, Select, MenuItem, Button, DialogContent, TextField, Grid, FormControlLabel, Divider, Chip, Stack } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Dialog } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { Add, AddBox, CheckBox, CheckBoxTwoTone, Delete, Edit, Square } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { DataGrid } from '@mui/x-data-grid';

// import { DataGrid } from '@mui/x-data-grid';
function Citymas() {
  const [CountryData, setCountryData] = useState(null);
  const [StateData, setStateData] = useState(null);
  const [SlelectedCountry, setSlelectedCountry] = useState(null);
  const [SlelectedState, setSlelectedState] = useState(null);
  const [CityData, setCityData] = useState(null);
  const [flg, setflg] = useState(false);
  const swal = useSwalWrapper();
  const HandleCitySave =async (data)=>{
    // console.log(data);
    const {FL_CITY_NAME, FL_CITY_CODE, FL_STATE_CD,FL_CITY_CD} = data;
      await jwtAuthAxios.post('master/cityaddEdit',
    { FL_CITY_NAME, FL_CITY_CODE, FL_STATE_CD,FL_CITY_CD
    }).then(res =>{
      swal.fire({
        icon:'success',
        text:res.data.message,
      })
      // callback()
      }).catch(()=>{
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
    })
  }
  const fetchCountryData = useCallback(() => {
    setCountryData(null)
    jwtAuthAxios.get(`master/helper?country=1`).then(res => {
      setCountryData(res.data.data.COUNTRY)
    })
  })
  useEffect(() => {
    fetchCountryData()
  }, [])
  useEffect(() => {
    SlelectedState && jwtAuthAxios.get(`master/helper?city=${SlelectedState}`).then(res => {
      setCityData(res.data.data.CITY)
    })
  }, [SlelectedState])

  useEffect(() => {
    // console.log(SlelectedCountry);
    SlelectedCountry && jwtAuthAxios.get(`master/helper?state=${SlelectedCountry}`).then(res => {
      setStateData(res.data.data.STATE)
    })
  }, [SlelectedCountry])
  const handleCellEditCommit = ({ id, field, props }) => {
    // console.log({ id, field, props });
      const updatedRows = CityData.map((row) => {
        if (row.id === id) {
          return { ...row, [field]: props.value };
        }
        return row;
      });
      setCityData(updatedRows);
    }

    const columns = [
      { field: 'FL_CITY_CD', headerName: 'CityCode', width: window.innerWidth / 8 },
      { field: 'FL_CITY_CODE', headerName: 'Code', editable: true, width: window.innerWidth / 8 },
      { field: 'FL_CITY_NAME', headerName: 'Name', editable: true, width: window.innerWidth / 2 },
      {
        field: '',
        align: 'end',
        headerName: 'Action',
        sortable: false,
        width: window.innerWidth / 5.4,
        renderCell: (params) => (
          <>
            <Button
              variant='contained'
              onClick={() => HandleCitySave(params.row)} // Make sure HandleCitySave is defined
              sx={{ mr: 2, ml: 'auto' }}
              color='primary'
            >
              Save
            </Button>
            {/* <Button variant='contained' color='error'>Remove</Button> */}
          </>
        ),
      },
    ];
    
  // const formEditSubmitHandler = async(row,iid)=>{
  //   const {FL_STATE_CD,FL_COUNTRY_NAME,FL_COUNTRY_CODE,FL_COUNTRY_SHORT} = row
  //   // console.log(row,document.getElementById(`detail-a-${index}`).value,document.getElementById(`detail-b-${index}`).value);
  //   // console.log({ FL_STATE_CD:FL_STATE_CD,
  //   //   FL_COUNTRY_NAME : document.getElementById(`${iid}-a`).value,
  //   //   FL_COUNTRY_CODE : document.getElementById(`${iid}-b`).value,
  //   //   FL_COUNTRY_SHORT : document.getElementById(`${iid}-c`).value
  //   // });
  //   // return
  //   await jwtAuthAxios.post('master/countryaddEdit',
  //   { FL_STATE_CD:FL_STATE_CD,
  //     FL_COUNTRY_CODE : document.getElementById(`${iid}-a`).value,
  //     FL_COUNTRY_NAME: document.getElementById(`${iid}-b`).value,
  //     FL_COUNTRY_SHORT : document.getElementById(`${iid}-c`).value
  //   }).then(res =>{
  //     swal.fire({
  //       icon:'success',
  //       text:res.data.message,
  //     })
  //     // callback()
  //     }).catch(()=>{
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //   })
  // }

  return (<>
    <Grid container>
      <Grid item xs={6}>
        <h2>City master</h2>
      </Grid>
      <Grid item xs={6}>
        <Stack direction={'row'} spacing={3} justifyContent={'end'}>
          <FormControl sx={{ mb: 2, display: 'block',width: 'fit-content' }}>
            <InputLabel>Select Country</InputLabel>
            <Select sx={{ width: 200 }} label={'Select Country'} value={SlelectedCountry} onChange={(e) => { setSlelectedCountry(e.target.value) }}>
              {CountryData?.map((country) => (
                <MenuItem key={country.FL_COUNTRY_CD} value={country.FL_COUNTRY_CD}>
                  {country.FL_COUNTRY_NAME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ mb: 2, display: 'block',width: 'fit-content' }}>
            <InputLabel>{StateData?.lenght > 0 ? 'Select State':'Please Select Country First'}</InputLabel>
            <Select sx={{ width: 200 }} disabled={StateData?.lenght > 0}  label={StateData?.lenght > 0 ? 'Select State':'Please Select Country first'} value={SlelectedState} onChange={(e) => { setSlelectedState(e.target.value) }}>
              {StateData?.map((state) => (
                <MenuItem key={state.FL_STATE_CD} value={state.FL_STATE_CD}>
                  {state.FL_STATE_NAME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
    </Grid>

    <Box >
    <Paper>
      <DataGrid
        rows={[...CityData || [],{FL_CITY_NAME:'', FL_CITY_CODE:'',FL_STATE_CD:SlelectedState ,FL_CITY_CD:null}]}
        columns={columns}
        autoHeight
        onCellEditCommit={handleCellEditCommit}
        density='compact'
        getRowId={(row) => row.FL_CITY_NAME}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
        }}
        pageSizeOptions={[50]}
        // checkboxSelection
        disableRowSelectionOnClick
      /></Paper>
    </Box>
    
    {/* {(SlelectedCountry && CountryData?.length >0 )? 
      <TableContainer  component={Paper}>
        <Table >
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>CODE</TableCell>
              <TableCell>NAME</TableCell>
              <TableCell>Country CODE</TableCell>
              <TableCell align='right'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {StateData?.map((Data,index)=> 
          <TableRow key={index}>
            <TableCell>{Data.FL_STATE_CD}</TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_STATE_CD}-a`} defaultValue={Data.FL_STATE_CODE} /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_STATE_CD}-b`} defaultValue={Data.FL_STATE_NAME} /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_STATE_CD}-c`} defaultValue={Data.FL_COUNTRY_CD} /></TableCell>
              <TableCell>
                <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler(Data,`detail-${Data.FL_STATE_CD}`)}} color='primary'>Save</LoadingButton>
                <LoadingButton variant='contained' size='small' sx={{ ml: 2 }} onClick={()=>{jwtAuthAxios.get('master/deleteCountrymsmas/'+Data.FL_STATE_CD).then(()=> {fetchCountryData()})}} color='error'>Delete</LoadingButton>
              </TableCell>
            </TableRow>)
          }
          <TableRow>
            <TableCell>{'-'}</TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-a`}  /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-b`}  /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-c`}  /></TableCell>
              <TableCell>
              <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler({FL_STATE_CD:null},`detail-new`)}} color='primary'>Save</LoadingButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer> :<TableSkeleton cols={7} />} */}
  </>
  );
}


Citymas.Modulename = 'citymas';

export default Citymas;
